// extracted by mini-css-extract-plugin
module.exports = {"row":"UserEdit_row__3D8fx","switchAdjust":"UserEdit_switchAdjust__1bx50"};